export default "__VITE_ASSET__CZttS1by__"